(() => {
  const fontStacks = {
    'Montserrat': '"Montserrat", sans-serif',
    'Instrument Sans': '"Instrument Sans", sans-serif',
    'Lora': '"Lora", serif',
    'Playfair Display': '"Playfair Display", serif',
    'Cinzel': '"Cinzel", serif',
    'Marcellus': '"Marcellus", serif',
    'Great Vibes': '"Great Vibes", cursive',
    'Allura': '"Allura", cursive'
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-ga-personalization]').forEach((panel) => {
      if (panel.dataset.gaBound === 'true') return;
      panel.dataset.gaBound = 'true';

      const nameInput = panel.querySelector('[data-ga-name]');
      const titleInput = panel.querySelector('[data-ga-title]');
      const preview = panel.querySelector('[data-ga-preview]');
      const namePreview = panel.querySelector('[data-ga-preview-name]');
      const titlePreview = panel.querySelector('[data-ga-preview-title]');
      const nameplate = panel.querySelector('[data-ga-nameplate]');
      const error = panel.querySelector('[data-ga-name-error]');

      const update = () => {
        const name = nameInput?.value.trim() || '';
        const title = titleInput?.value.trim() || '';
        const hasContent = Boolean(name || title);
        if (preview) preview.hidden = !hasContent;
        if (namePreview) {
          namePreview.textContent = name;
          namePreview.hidden = !name;
        }
        if (titlePreview) {
          titlePreview.textContent = title;
          titlePreview.hidden = !title;
        }
        const font = panel.querySelector('[data-ga-font]:checked')?.value || 'Montserrat';
        if (namePreview) namePreview.style.fontFamily = fontStacks[font] || fontStacks.Montserrat;
        const accessory = panel.querySelector('[data-ga-accessory]:checked')?.value || 'Gold';
        if (nameplate) nameplate.dataset.accessoryColor = accessory.toLowerCase();
      };

      const clearError = () => {
        error?.setAttribute('hidden', '');
        nameInput?.removeAttribute('aria-invalid');
      };
      const showError = () => {
        error?.removeAttribute('hidden');
        nameInput?.setAttribute('aria-invalid', 'true');
      };

      nameInput?.addEventListener('input', () => { clearError(); update(); });
      titleInput?.addEventListener('input', update);
      panel.querySelectorAll('[data-ga-font], [data-ga-accessory]').forEach((input) => input.addEventListener('change', update));
      panel.closest('form')?.addEventListener('submit', (event) => {
        if (!nameInput?.value.trim()) {
          event.preventDefault();
          showError();
          nameInput?.focus();
        }
      });
      update();
    });
  };

  initialize();
  if (!window.gaPersonalizationSectionListener) {
    window.gaPersonalizationSectionListener = true;
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  }
})();